import { render, staticRenderFns } from "./LmsMssComponent.vue?vue&type=template&id=080caac3&scoped=true"
import script from "./LmsMssComponent.vue?vue&type=script&lang=js"
export * from "./LmsMssComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080caac3",
  null
  
)

export default component.exports